const size = {
  minHeight: '700px',
  mobileS: '320px',
  mobileL: '425px',
  tablet: '768px',
  laptop: '1024px',
  laptopL: '1440px',
  desktop: '1920px',
};

export const device = {
  minHeight: `(min-height: ${size.minHeight})`,
  mobileS: `(min-width: ${size.mobileS})`,
  mobileL: `(min-width: ${size.mobileL})`,
  tablet: `(min-width: ${size.tablet})`,
  laptop: `(min-width: ${size.laptop})`,
  laptopL: `(min-width: ${size.laptopL})`,
  desktop: `(min-width: ${size.desktop})`,
  ipad: `(min-device-width : ${size.tablet}) and (max-device-width :  ${size.laptop}) and (orientation : portrait)`,
};
